class ButtonFilter {
  constructor() {
    const btnFilters = document.querySelectorAll(".btn--filter");
    const partnersTiles = document.querySelectorAll(".partners__tiles__card");
    const btnAll = document.querySelector(".btn--filter.cat-all");

    btnFilters.forEach(btn => {
      btn.addEventListener("click", function (e) {

        btnFilters.forEach(btn => {
          btn.classList.remove("act");
        })
        e.target.classList.add("act");

        partnersTiles.forEach(tile => {
          if (e.target.getAttribute('data-cat') === tile.getAttribute('data-cat')) {
            tile.style.display = 'block';
          } else {
            tile.style.display = 'none';
          }
        })
      })
    });

    if (btnAll) {
      btnAll.addEventListener("click", () => {
        partnersTiles.forEach(tile => {
          tile.style.display = 'block';
        })
      });
    }

  }
}
export default ButtonFilter
